module.exports = __webpack_public_path__ + "static/pic_androidStudent-b05523c9cc52ad8937863a790c50aad8.png";